module.exports = __webpack_public_path__ + "media/images/talent/lp/ambassador/mv-53a3ce44af534c5815cd6b73c189b719.png";